import React from 'react';
import { DatePicker, DatePickerChange } from '@tag/tag-components-react-v4';

import dayjs from 'dayjs';

import styles from './date-picker-tag4.module.scss';
import { getDateWithProperTimeOffset } from '@/utils/date.utils';

export type IDatePickerTag4 = {
  disabled?: boolean;
  inputStyle?: React.CSSProperties;
  defaultValue?: Date;
  value?: Date | null;
  onChange?: ((event: DatePickerChange) => void)
  name?: string;
  pickerSize?: 'small' | 'default'
  clearButton?: boolean;
  id?: string;
  placeholder?: string;
};

function DatePickerTag4(props: IDatePickerTag4) {
  const {
    disabled = false,
    onChange,
    pickerSize = 'default',
    clearButton = false,
    value,
    placeholder = 'dd/mm/yyyy', // Default fallback
    ...restProps
  } = props;

  const handleChange = (event: DatePickerChange) => {
    const localDate = event.localDate ?? event.value;
    const date = localDate ? dayjs(localDate).startOf('day').toDate() : undefined;
    onChange?.({
      ...event,
      value: date ? getDateWithProperTimeOffset(date) : event.value
    });
  };
  return (
    <div className={styles.dateContainer}>
      <DatePicker
        {...restProps}
        disabled={disabled}
        onChange={handleChange}
        pickerSize={pickerSize}
        clearButton={clearButton}
        value={value ?? null}
        placeholder={placeholder}
      />
    </div>
  );
}

export default DatePickerTag4;
